import { createRouterClient } from '@nest/common-core-frontend-react';
import { TerminalRouter } from '@nest/terminal-router';
import { environment } from './environment';

export const routerClient = createRouterClient<TerminalRouter>({
	url: environment.apiUrl,
	loggedOutRedirectUrl: '/login'
});

export function useTerminalClient() {
	return routerClient;
}
